export default angular.module('cian.newbuild.directionFilter', [])
.filter('direction', [() =>
  input => {
    switch (input) {
      case 'nw':
        return 'северо-запад';
        break;
      case 'w':
        return 'запад';
        break;
      case 'sw':
        return 'юго-запад';
        break;
      case 'n':
        return 'север';
        break;
      case 'center':
        return 'центр';
        break;
      case 's':
        return 'юг';
        break;
      case 'ne':
        return 'северо-восток';
        break;
      case 'e':
        return 'восток';
        break;
      case 'se':
        return 'юго-восток';
        break;
      default:
        return input;
    }
  },
])
.name;



// WEBPACK FOOTER //
// ./src/serp/filters/direction.filter.js